module.exports = __webpack_public_path__ + "img/stock6.7101c8da.png";